import React, { useRef } from "react";

export const DialpadContext = React.createContext();

class DialpadRenderer extends React.Component {
  canvasRef;
  canvasSize = 0;
  discFillColor = "";
  discStrokeColor = "";
  circlesFillColor = "";
  circlesStrokeColor = "";
  circlesHighlightColor = "";
  textFillColor = "";
  textStrokeColor = "";
  callback = () => {};

  constructor(props) {
    super(props);

    // if (process.env.NODE_ENV !== 'production') {
    //   checkIndexBounds(props);
    // }
    this.canvasRef = React.createRef()
    this.state = {
      a: 1,
      initialNumber: null,
      clicking: false,
      number: null,
      newAngle: 0,
      lastAngle: 0,
      returnSpeed: 0,
      canvasSize: props.canvasSize
    };
    this.discFillColor = props.discFillColor || "transparent";
    this.discStrokeColor = props.discStrokeColor || "black";
    this.circlesFillColor = props.circlesFillColor || "black";
    this.circlesStrokeColor = props.circlesStrokeColor || "transparent";
    this.circlesHighlightColor = props.circlesHighlightColor || "red";
    this.textFillColor = props.textFillColor || "white";
    this.textStrokeColor = props.textStrokeColor || "transparent";
    this.arrowFillColor = props.arrowFillColor || "black";
    this.arrowStrokeColor = props.arrowStrokeColor || "transparent";


    this.callback = props.callback || console.log;

    // document.body.appendChild(this.canvas);

    // const canvasRef = useRef(null);
    // this.setIndexCurrent(props.index);
  }

  componentDidMount() {
    this.size = this.state.canvasSize - 2;
    this.canvas = this.canvasRef.current;
    this.canvas.width = this.w = this.state.canvasSize;
    this.canvas.height = this.h = this.state.canvasSize;
    this.w2 = this.w / 2;
    this.h2 = this.h / 2;
    this.TWOPI = Math.PI * 2;
    this.offset = this.size * 0.25;
    this.outerCircle = this.size / 2;
    this.innerCircle = this.outerCircle - this.offset;

    this.c = this.canvas.getContext("2d");
    this.c.font = this.size * 0.08 + "px Arial";
    this.c.textAlign = "center";
    this.draw();
    this.addEvent();
  }
  componentDidUpdate(){
    this.size = this.state.canvasSize - 2;
    this.canvas = this.canvasRef.current;
    this.canvas.width = this.w = this.state.canvasSize;
    this.canvas.height = this.h = this.state.canvasSize;
    this.w2 = this.w / 2;
    this.h2 = this.h / 2;
    this.TWOPI = Math.PI * 2;
    this.offset = this.size * 0.25;
    this.outerCircle = this.size / 2;
    this.innerCircle = this.outerCircle - this.offset;

    this.c = this.canvas.getContext("2d");
    this.c.font = this.size * 0.08 + "px Arial";
    this.c.textAlign = "center";
    this.draw();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ canvasSize: nextProps.canvasSize });
  }

  draw() {
    this.c.clearRect(0, 0, this.w, this.h);
    this.c.beginPath();
    this.c.arc(this.w2, this.h2, this.outerCircle, 0, this.TWOPI, false);
    this.c.moveTo(this.w2 + this.innerCircle, this.h2);
    this.c.arc(this.w2, this.h2, this.innerCircle, this.TWOPI, 0, true);
    this.c.fillStyle = this.discFillColor;
    this.c.fill();
    this.c.strokeStyle = this.discStrokeColor;
    this.c.stroke();
    this.c.save();
    this.c.translate(this.w2, this.h2);
    for (let i = 0; i < 10; i++) {
      const a = this.state.a + i / 2;
      
      const center =
        this.innerCircle + (this.outerCircle - this.innerCircle) / 2;
      const x = Math.cos(a) * center;
      const y = Math.sin(a) * center;
      const n = (10 - i) % 10;
    //   console.log("hereee:",x,y,n)
      this.c.beginPath();
      this.c.arc(x, y, this.size * 0.08, 0, this.TWOPI);
      this.c.fillStyle = this.circlesFillColor;
      this.c.strokeStyle = this.circlesStrokeColor;
      if (this.number != null && this.number % 10 == n)
        this.c.fillStyle = this.circlesHighlightColor;
      this.c.fill();
      this.c.stroke();
      this.c.fillStyle = this.textFillColor;
      this.c.strokeStyle = this.textStrokeColor;
      this.c.fillText(n, x, y + this.size * 0.02);
      this.c.strokeText(n, x, y + this.size * 0.02);
    }

    this.c.restore();
    // this.c.beginPath();
    // this.c.moveTo(this.w - this.size * 0.08, this.h2);
    // this.c.lineTo(this.w, this.h2 - this.size * 0.04);
    // this.c.lineTo(this.w, this.h2 + this.size * 0.04);
    // this.c.closePath();
    // this.c.fillStyle = this.arrowFillColor;
    // this.c.strokeStyle = this.arrowStrokeColor;
    // this.c.fill();
    // this.c.stroke();
  }

  addEvent() {
    this.canvas.addEventListener("mousedown", (e) => {
      this.isClicking(e);
    });

    this.canvas.addEventListener("mouseup", (_) => {
      this.result();
    });

    this.canvas.addEventListener("mouseout", (_) => {
      this.clear();
    });

    this.canvas.addEventListener("mousemove", (e) => {
      this.rotate(e);
    });

    this.canvas.addEventListener("touchstart", (e) => {
      this.isClicking(e);
    });

    this.canvas.addEventListener("touchmove", (e) => {
      this.rotate(e);
    });

    this.canvas.addEventListener("touchend", (_) => {
      this.result();
    });
  }

  result() {
    console.log("result called!",this.state.number)
    if (this.state.number) {
      let number = this.state.number;
      let returnAudio = document.getElementById("ret" + (number % 10));
      let duration = returnAudio.duration;
      let returnSpeed = (number * 0.5 + 0.5) / (duration * 60);
      this.setState({ returnSpeed:0.05 });
      number = number % 10;
      // console.log("returnSpeed: ",this.returnSpeed)
      returnAudio.play();
      this.callback(number);
    }

    this.clear();
  }

  isClicking(e) {
    e.preventDefault();
    const pos = this.getPos(e);
    const dist = this.getDist(pos.x, pos.y, this.w2, this.h2);
    if (dist > this.size / 2 || dist < this.size / 2 - this.offset) return;

    let lastAngle = Math.atan2(pos.y - this.h2, pos.x - this.w2);

    // this.number = null;
    // this.clicking = true;
    let angle = -Math.atan2(pos.y - this.h2, pos.x - this.w2);
    angle = angle > 0 ? angle : angle + this.TWOPI;
    let n = Math.floor((angle - 0.5) / 0.5) + 1;
    // this.initalNumber = n;

    this.setState({
      lastAngle,
      number: null,
      clicking: true,
      initialNumber: n,
    });
  }

  getDist(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
  }

  getPos(e) {
    e.preventDefault();
    let x, y;
    const rect = this.canvas.getBoundingClientRect();
    const _x = this.canvas.width / rect.width;
    const _y = this.canvas.height / rect.height;
    if (e.touches) {
      x = (e.targetTouches[0].pageX - rect.left) * _x;
      y = (e.targetTouches[0].pageY - rect.top) * _y;
    } else {
      x = e.offsetX * _x;
      y = e.offsetY * _y;
    }
    return { x, y };
  }

  clear() {
    console.log("clear called")
    // this.number = null;
    // this.initalNumber = null;
    // this.clicking = false;
    this.setState({ number: null, initialNumber: null, clicking: false });
    this.goBack();
  }

  rotate(e) {
    if (!this.state.clicking || this.state.a >= this.TWOPI) return;
    if (this.state.a < 1) {
      this.setState({ a: 1 });
      //   this.a = 1;
      return;
    }
    const pos = this.getPos(e);
    const dist = this.getDist(pos.x, pos.y, this.w2, this.h2);
    if (dist > this.size / 2 || dist < this.size / 2 - this.offset) {
      this.clear();
      return;
    }
    const n = Math.floor(((this.state.a - 0.7) / (this.TWOPI - 0.8)) * 11);
    if (n > this.state.initialNumber) {
      // this.clear()
      return;
    }
    let number = n > 0 ? n : null;
    console.log(n)
    let newAngle = Math.atan2(pos.y - this.h2, pos.x - this.w2);

    const delta = this.state.a - (this.state.lastAngle - newAngle);
    let a = delta > 0 ? delta : this.TWOPI + delta;
    // this.lastAngle = this.newAngle;

    this.setState({ number, newAngle, a, lastAngle: newAngle });
    this.draw();
  }

  goBack() {
    // console.log("gobackCalled",this.state.a,this.state.returnSpeed)
    let a;
    if (this.state.a > 1) {
      a = this.state.a - (this.state.returnSpeed || 0.05);
      this.draw();
      requestAnimationFrame((_) => {
        this.goBack();
      });
      if (this.state.a - 1 < 0.05) a = 1;
      this.setState({ a });
    }
  }

  componentWillUnmount() {
    this.transitionListener.remove();
    this.touchMoveListener.remove();
    clearTimeout(this.firstRenderTimeout);
  }

  render() {
    const {} = this.state;
    return (
      <DialpadContext.Provider
        // value={this.getDialpadRendrerContext()}
      >
        <div style={{ ...this.props.style,width: this.props.canvasSize+"px",height:this.props.canvasSize+"px"}}>
        <canvas
          width={this.props.canvasSize}
          height={this.props.canvasSize}
          ref={this.canvasRef}
          style={{borderRadius:"50%"}}
        //   {...props}
        />
        {[...Array(10).keys()].map((key)=>{
            return(<audio controls id={"ret"+key} hidden>
                    <source src={`${process.env.PUBLIC_URL}/assets/sfx/ret${key}.mp3`} type="audio/mpeg" />
                  </audio>)
        })}
        
      </div>
      </DialpadContext.Provider>
    );
  }
}

export default DialpadRenderer;
